var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.625 33.75A20.625 20.625 0 0 1 26.25 13.125 1.875 1.875 0 0 1 28.125 15v16.875H45a1.875 1.875 0 0 1 1.875 1.875 20.625 20.625 0 0 1-41.25 0z",
    fill: "#F9A11E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.875 7.5a1.875 1.875 0 0 1 1.875-1.875A20.625 20.625 0 0 1 54.375 26.25a1.875 1.875 0 0 1-1.875 1.875H33.75a1.875 1.875 0 0 1-1.875-1.875V7.5z",
    fill: "#799FD3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.6665d4ce14aa51cde6dd3fa8bef1bc21.svg";
export { ForwardRef as ReactComponent };